import * as React from 'react';

import { getRangeValue, getTermValue } from '../../../../../JsonQuery';
import { useDealType } from '../../../utils/useDealType';
import { useOfferType } from '../../../utils/useOfferType';
import { useContext } from '../../../utils/useContext';
import { Price } from '../../../components/filters/Price';

export const PriceContainer: React.FC = () => {
  const { jsonQuery, onChange } = useContext();
  const dealType = useDealType();
  const offerType = useOfferType();
  const price = getRangeValue('price')(jsonQuery);
  const isSquareMeterPrice = getTermValue('price_sm')(jsonQuery);

  const handlePriceMinChange = React.useCallback(
    (gte: number | null) => {
      onChange({ action: 'setPriceMin', arguments: [gte] });
    },
    [onChange],
  );

  const handlePriceMaxChange = React.useCallback(
    (lte: number | null) => {
      onChange({ action: 'setPriceMax', arguments: [lte] });
    },
    [onChange],
  );

  const handlePriceTypeChange = React.useCallback(
    (isSquareMeterPrice: boolean | null) => {
      onChange({ action: 'setPriceType', arguments: [isSquareMeterPrice] });
    },
    [onChange],
  );

  return (
    <Price
      dealType={dealType}
      offerType={offerType}
      price={price}
      isSquareMeterPrice={isSquareMeterPrice}
      onPriceMinChange={handlePriceMinChange}
      onPriceMaxChange={handlePriceMaxChange}
      onPriceTypeChange={handlePriceTypeChange}
    />
  );
};
